import { initializeApp } from 'firebase/app';
import { initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { env, hasRealFirebaseConfig, isDev } from './env';

const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

// Only enforce App Check if we have real credentials, avoiding breakage in offline dev mode.
if (
  typeof window !== 'undefined' &&
  hasRealFirebaseConfig() &&
  env.VITE_APP_CHECK_SITE_KEY !== 'mock-site-key'
) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(env.VITE_APP_CHECK_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export const db = initializeFirestore(app, { ignoreUndefinedProperties: true });
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-southeast1');

// Emulator-first local dev (see docs/superpowers/plans/archive/2026-06-12-retire-offline-dual-path.md).
// Gated on an explicit flag, NOT bare isDev() — dev against real Firebase must
// stay possible during the migration, and the old unconditional dev
// connectFunctionsEmulator silently broke CF calls when no emulator ran.
const useEmulators = isDev() && env.VITE_USE_EMULATORS === 'true';
if (useEmulators) {
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
export const isEmulatorMode = useEmulators;
